export const accessEnum = {
  TARIFF_DUTIES_MODULE_ACCESS: "tariff_duties_module_access",
  CONTROLS_SEARCH_MODULE_ACCESS: "controls_search_module_access",
  ECCN_SEARCH_MODULE_ACCESS: "eccn_search_module_access",
  ECCN_LICENSES_DETERMINATION_MODULE_ACCESS: "eccn_licenses_determination_module_access",
  DOCUMENT_DETERMINATION_MODULE_ACCESS: "document_determination_module_access",
  EMBARGOES_MODULE_ACCESS: "embargoes_module_access",

  ALL_SKUS_MODULE_ACCESS: "all_skus_module_access",
  ALL_SKUS_UPLOAD_PRODUCT: "all_skus_upload_product",
  ALL_SKUS_CLASSIFICATION_REQUEST: "all_skus_classification_request",
  ALL_SKUS_RECLASSIFY_REQUEST: "all_skus_reclassify_request",
  ALL_SKUS_VIEW_SKU: "all_skus_view_sku",
  ALL_SKUS_EDIT: "all_skus_edit",
  ALL_SKUS_VIEW_LOGS: "all_skus_view_logs",

  CLASSIFICATION_REQUEST_MODULE: "classification_request_module",
  ASSIGN_REQUEST_CR: "assign_request_cr",
  EDIT_REQUEST_CR: "edit_request_cr",
  EDIT_REQUEST_CR_MT: "edit_request_cr_mt",
  VIEW_REQUEST_LOGS_CR: "view_request_logs_cr",
  VIEW_REQUEST_LOGS_CR_MT: "view_request_logs_cr_mt",
  TRIGGER_BULK_CLASSIFICATION_MODEL: "trigger_bulk_classification_model",
  START_CLASSIFICATION_CR: "start_classification_cr_mt",
  VIEW_SKU_DETAILS: "view_sku_details",

  UPLOAD_LOGS_MODULE: "upload_logs_module",
  UPLOAD_LOGS_DOWNLOAD_REPORT: "upload_logs_download_report",
  UPLOAD_LOGS_DOWNLOAD_UPLOADED_FILE: "upload_logs_download_uploaded_file",

  VIEW_ESCALATIONS: "escalate_classification_request",
  VIEW_CONTROLS: "view_controls",
  VIEW_DUTIES: "view_duties",

  WATCHLIST_MODULE_ACCESS: "watchlist_module_access",
  DISABLE_WATCHLIST: "disable_watchlist",
  ADD_WATCHLIST: "add_watchlist",

  MY_TASKS_MODULE_ACCESS: "my_tasks_module_access",
  VIEW_RFI_REQUESTS: "view_rfi_requests",
  REQUESTS_DASHBOARD_MODULE_ACCESS: "requests_dashboard_module_access",

  BOM_MASTER_MODULE_ACCESS: "bom_master_module_access",
  ALL_SKU_OVERVIEW: "all_sku_overview",
  REQUESTS_DASHBOARD_SUBMODULE_ACCESS: "requests_dashboard_submodule_access",

  RISK_CONFIGURATION_ACCESS: "risk_configuration_access",

  PARTNER_MASTER_MODULE_ACCESS: "partner_master_module_access",
  PARTNER_MASTER_DOWNLOAD: "partner_master_download",
  PARTNER_MASTER_BULK_UPLOAD: "partner_master_bulk_upload",
  PARTNER_MASTER_UPDATE: "partner_master_update",

  TRADE_LANE_MASTER_MODULE_ACCESS: "trade_lane_master_module_access",
  TRADE_LANE_MASTER_DOWNLOAD: "trade_lane_master_download",
  TRADE_LANE_MASTER_BULK_UPLOAD: "trade_lane_master_bulk_upload",
  TRADE_LANE_MASTER_UPDATE: "trade_lane_master_update",

  SUPPLIER_SOLICITATION_MODULE_ACCESS: "supplier_solicitation_module_access",

  NEXA_AI_MODULE_ACCESS: "nexa_ai_module_access"
};
